import { FC, ReactNode } from 'react'
import cn from 'classnames'

import s from './OrderFilterLabel.module.less'

export interface OrderFilterLabelProps {
  title: string
  children?: ReactNode
  count?: number
}

export const OrderFilterLabel: FC<OrderFilterLabelProps> = ({ title, count, children }) => (
  <div className={cn(s.filterLabel, count ? s.filterLabelActive : '')}>
    <div>
      {title}
      {count ? <span>: </span> : ''}
    </div>
    <div>
      <span className={s.isShowFilter}>{children}</span>
    </div>
  </div>
)
